import React, { useState } from "react";
import Nav from "./Navigation.js";

const paintingsData = [
  { id: 1, name: "Batuhan", imagePath: "Batuhan.PNG", aka: "Chair" },
  { id: 2, name: "Ben", imagePath: "Ben.PNG", aka: "Brown Suit" },
  { id: 3, name: "Fabio", imagePath: "Fabio.PNG", aka: " 'Hello there' " },
  { id: 4, name: "Faiter", imagePath: "Faiter.PNG", aka: "Banister" },
  { id: 5, name: "Greedy", imagePath: "Greedy.PNG", aka: "Soul" },
  { id: 6, name: "Gryphon", imagePath: "Gryphon.PNG", aka: "Smokes" },
  { id: 7, name: "Hayley", imagePath: "Hayley.PNG", aka: "Pink Dress" },
  { id: 8, name: "Igor", imagePath: "Igor.PNG", aka: "Cigar N Scotch" },
  { id: 9, name: "Leonid", imagePath: "Leonid.PNG", aka: "White Suit" },
  { id: 10, name: "Michal", imagePath: "Michal.PNG", aka: "Hefner" },
  { id: 11, name: "Muhammed", imagePath: "Muhammed.PNG", aka: "Gomez Adams" },
  { id: 12, name: "Nanque", imagePath: "Nanque.PNG", aka: "Blue Dress" },
  { id: 13, name: "Ozan", imagePath: "Ozan.PNG", aka: "Red Suit" },
  { id: 14, name: "Shadow", imagePath: "Shadow.PNG", aka: "Side Beard" },
  { id: 15, name: "Tanner", imagePath: "Tanner.PNG", aka: "Ruffles" },
  { id: 16, name: "Zak", imagePath: "Zak.PNG", aka: "Table" },
];

export default function PaintingSolver({ isModal = false, onClose }) {
  const [selectedItems, setSelectedItems] = useState([]);

  const handleItemClick = (name) => {
    if (selectedItems.length < 4 && !selectedItems.includes(name)) {
      setSelectedItems([...selectedItems, name]);
    }
  };

  const handleResetClick = () => {
    setSelectedItems([]);
  };

  const renderPlaceholder = (index) => (
    <div key={index} style={{ height: "210px" }} />
  );

  const renderItem = (painting) => (
    <div key={painting.name} className="text-center">
      <img
        className="object-scale-down h-24 sm:h-28 md:h-32 lg:h-36 cursor-pointer mx-auto"
        src={require(`../images/${painting.imagePath}`)}
        alt={painting.name}
        onClick={() => handleItemClick(painting.name)}
      />
      <div>{painting.name}</div>
      {!isModal && (
        <>
          <div>aka {painting.aka}</div>
        </>
      )}
    </div>
  );

  return (
    <div
      className={`text-white bg-black min-h-screen ${
        isModal ? "fixed inset-0 z-50 overflow-y-auto bg-opacity-90" : ""
      }`}
    >
      <div
        className={`relative ${
          isModal
            ? "bg-gray-900 p-8 rounded-lg w-[90%] max-w-4xl mx-auto my-8"
            : "px-4 py-8"
        }`}
      >
        {/* Close Button (Top-Right) */}
        {isModal && (
          <button
            onClick={onClose}
            className="absolute top-4 right-4 bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 z-50"
          >
            ✕
          </button>
        )}

        {!isModal && <Nav />}

        <div className="text-center mb-4">
          Directions: To use this, simply click on any four pictures and it will store the order
        </div>

        <div className="flex justify-center space-x-4 mb-4 flex-wrap">
          {selectedItems.map((name) => (
            <div key={name}>
              {renderItem(paintingsData.find((p) => p.name === name))}
            </div>
          ))}
          {Array.from({ length: 4 - selectedItems.length }).map((_, index) =>
            renderPlaceholder(index)
          )}
        </div>

        <div className="flex justify-center mb-4">
          {selectedItems.length > 0 && (
            <button
              onClick={handleResetClick}
              className="bg-black border-solid border-2 border-white text-white px-4 py-2 rounded"
            >
              Reset Selection
            </button>
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4 mb-4">
          {paintingsData.map((painting) => (
            <div key={painting.id}>{renderItem(painting)}</div>
          ))}
        </div>
      </div>
    </div>
  );
}
